export interface AlmeApiUtilsConfig {
    apiUtils: {
        errorResponse: {
            entryId: string;
        };
        uiVersion: string;
    };
}

/**
 * This is the baseline alme api utils config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeApiUtilsConfig = {
    apiUtils: {
        uiVersion: process.env.VERSION || '0.0.0',
        errorResponse: {
            entryId: '00000000-0000-0000-0000-000000000000',
        },
    },
};

export default defaultConfig;